import BaseModel from './BaseModel';
import { db } from '../utilities';
import { collection, doc, query, where, getDocs, getDoc, documentId } from 'firebase/firestore';

export default class Meta extends BaseModel {
  constructor() {
    super(collection(db, 'meta'));
  }

  static async getRubricsByFormId(formId: string) {
    const rubricsSnapshot = await getDocs(query(collection(db, 'rubrics'), where('formId', '==', formId)));
    const rubrics: any[] = [];
    rubricsSnapshot.forEach((d) => {
      rubrics.push({ id: d.id, ...d.data() });
    });
    return rubrics;
  }

  static async getOrganizationsByUserId(userId: string) {
    const userDoc = await getDoc(doc(db, 'users', userId));
    const organizationId = userDoc.data()?.organization.id;

    const orgAssociationsDoc = await getDoc(doc(db, 'org_associations', organizationId));
    const clientWhereOwner = orgAssociationsDoc.data()?.clientWhereOwner || [];

    const fetchOrganizationsBatch = async (batch: any) => {
      const organizationsSnapshot = await getDocs(
        query(collection(db, 'organizations'), where(documentId(), 'in', batch))
      );
      const organizations: any[] = [];
      organizationsSnapshot.forEach((d) => {
        organizations.push({ id: d.id, ...d.data() });
      });
      return organizations;
    };

    const organizations = [];
    for (let i = 0; i < clientWhereOwner.length; i += 10) {
      const batch = clientWhereOwner.slice(i, i + 10);
      const batchOrganizations = await fetchOrganizationsBatch(batch);
      organizations.push(...batchOrganizations);
    }

    return organizations;
  }
}
